import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'configuration-accelerators-tab-1-part',
	standalone: true,
	templateUrl: './configuration-accelerators-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./configuration-accelerators-tab-1.part.scss`],
})
export class ConfigurationAcceleratorsTab1Part {
}
